import { hubs } from "~/lib/signalr";
import { FocusedPickSignalRMessage, SignalRPickEventDto } from "~/types/api";

import autostorePickingApi from "./autostorePicking";
import {
  streamGetBatchPickingStateUpdates,
  streamGetPickingStateV1Updates
} from "./autostorePicking.streaming";

export const {
  useGetFocusedPickQuery,
  useLazyGetFocusedPickQuery,
  useGetTotesForBatchQuery,
  useRepickProductsMutation,
  useGetPickingStateV1Query,
  useGetBatchPickingStateQuery,
  useOutOfStockPickMutation,
  usePickBatchMutation,
  useStartPickingOnWorkstationMutation,
  useNextPickBinMutation
} = autostorePickingApi.enhanceEndpoints({
  addTagTypes: [],
  endpoints: {
    getFocusedPick: {
      async onCacheEntryAdded(
        { workstationId },
        { cacheDataLoaded, cacheEntryRemoved, ...rest }
      ) {
        await cacheDataLoaded;
        const subscriptionFocusedPick = hubs.focusedPick.subscribe({
          next: (event: FocusedPickSignalRMessage) => {
            rest.updateCachedData(() => {
              if (workstationId === event.workstationId) {
                return event.focusedPick;
              }
              return;
            });
          }
        });
        // this is for the old picking state and can be removed when focused pick reliable.
        const subscriptionPickingState = hubs.pick.subscribe({
          next: (event: SignalRPickEventDto) => {
            rest.updateCachedData((draft) => {
              if (draft?.pickId === event.pick.pickId) {
                return { ...draft, status: event.pick.status };
              }
              return;
            });
          }
        });
        await cacheEntryRemoved;
        subscriptionFocusedPick.unsubscribe();
        subscriptionPickingState.unsubscribe();
      }
    },
    getPickingStateV1: {
      onCacheEntryAdded: streamGetPickingStateV1Updates
    },
    getBatchPickingState: {
      onCacheEntryAdded: streamGetBatchPickingStateUpdates
    }
  }
});
